import { Form, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useGetCategoriesList } from '../../../../utils/api/categories/useGetCategoriesList';
import { useGetMpCategories } from '../../../../utils/api/mpCategories/useGetMpCategories';
import { PRODUCT_FILTERS } from '../../../../utils/const/product';

const ProductFilters = ({ t, setFilters, filters }) => {
  const [searchedCategory, setSearchedCategory] = useState(null);
  const [searchedCategoryInput, setSearchedCategoryInput] = useState(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchedCategory(searchedCategoryInput);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchedCategoryInput]);
  const { categories, isLoading } = useGetCategoriesList(
    {
      search: searchedCategory,
      brands: filters?.brand?.join(','),
      range: filters?.range,
      composition: filters?.composition,
      types: filters?.type?.join(','),
      categories_mp: filters?.mp_category?.join(','),
      categories_mp_to_exclude: filters?.not_in_mp_category?.join(','),
      limit: 100,
    },
    {},
    true
  );

  const [searchedMpCategoryInput, setSearchedMpCategoryInput] = useState(null);
  const [searchedMpCategory, setSearchedMpCategory] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchedMpCategory(searchedMpCategoryInput);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchedMpCategoryInput]);
  const { mpCategories, isLoading: isLoadingMpCategories } = useGetMpCategories(
    {
      search: searchedMpCategory,
      brands: filters?.brand?.join(','),
      range: filters?.range,
      composition: filters?.composition,
      types: filters?.type?.join(','),
      categories: filters?.category?.join(','),
      without_attributes: true,
      limit: 100,
    }
  );

  const [rangeValue, setRangeValue] = useState(filters?.range || '');
  const [compositionValue, setCompositionValue] = useState(
    filters?.composition || ''
  );

  // Debounce pour le filtre range
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters((prev) => ({ ...prev, range: rangeValue || undefined }));
    }, 500);

    return () => clearTimeout(timer);
  }, [rangeValue, setFilters]);

  // Debounce pour le filtre composition
  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters((prev) => ({
        ...prev,
        composition: compositionValue || undefined,
      }));
    }, 500);

    return () => clearTimeout(timer);
  }, [compositionValue, setFilters]);

  const handleCategoryChange = (value) => {
    setSearchedCategoryInput(null);
    setFilters({ ...filters, category: value });
  };

  const handleBrandChange = (value) => {
    setFilters({ ...filters, brand: value });
  };
  const handleMpCategoryChange = (value) => {
    setSearchedMpCategoryInput(null);
    setFilters({ ...filters, mp_category: value });
  };
  const handleMpisNotCategoryChange = (value) => {
    setSearchedMpCategoryInput(null);
    setFilters({ ...filters, not_in_mp_category: value });
  };

  const handleTypeChange = (value) => {
    setFilters({ ...filters, type: value });
  };

  return (
    <Form layout="vertical" style={{ width: '100%' }}>
      <h4>Filtres</h4>
      <Form.Item label={'Catégorie Brute'} style={{ marginBottom: 12 }}>
        <Select
          mode="multiple"
          allowClear
          loading={isLoading}
          size="small"
          placeholder={t('filters.category')}
          value={filters?.category}
          showSearch={true}
          style={{ width: '100%' }}
          filterOption={false}
          onChange={handleCategoryChange}
          searchValue={searchedCategoryInput}
          onSearch={setSearchedCategoryInput}
          options={categories?.map((category) => ({
            label: category.name,
            value: category.id,
          }))}
        />
      </Form.Item>
      <Form.Item label={t('filters.brand')} style={{ marginBottom: 12 }}>
        <Select
          mode="multiple"
          allowClear
          size="small"
          placeholder={t('filters.brand')}
          style={{ width: '100%' }}
          showSearch={true}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          onChange={handleBrandChange}
          options={PRODUCT_FILTERS.brand.map((brand) => ({
            label: t(`brands.${brand}`),
            value: brand,
          }))}
        />
      </Form.Item>
      <Form.Item label="Gamme" style={{ marginBottom: 12 }}>
        <Input
          allowClear
          size="small"
          placeholder="Rechercher une gamme"
          style={{ width: '100%' }}
          value={rangeValue}
          onChange={(e) => setRangeValue(e.target.value)}
        />
      </Form.Item>
      <Form.Item label="Composition" style={{ marginBottom: 12 }}>
        <Input
          allowClear
          size="small"
          placeholder="Rechercher une composition"
          style={{ width: '100%' }}
          value={compositionValue}
          onChange={(e) => setCompositionValue(e.target.value)}
        />
      </Form.Item>
      <Form.Item label="Type" style={{ marginBottom: 12 }}>
        <Select
          mode="multiple"
          allowClear
          size="small"
          placeholder="Sélectionner un type"
          style={{ width: '100%' }}
          onChange={handleTypeChange}
          options={PRODUCT_FILTERS.type}
        />
      </Form.Item>
      <Form.Item
        label="Présent dans la catégorie MP"
        style={{ marginBottom: 12 }}
      >
        <Select
          mode="multiple"
          allowClear
          size="small"
          placeholder="Sélectionner une catégorie"
          style={{ width: '100%' }}
          loading={isLoadingMpCategories}
          showSearch={true}
          filterOption={false}
          onChange={handleMpCategoryChange}
          searchValue={searchedMpCategoryInput}
          onSearch={setSearchedMpCategoryInput}
          options={mpCategories?.map((category) => ({
            label: category.name,
            value: category.id,
          }))}
        />
      </Form.Item>
      <Form.Item
        label="Non présent dans la catégorie MP"
        style={{ marginBottom: 12 }}
      >
        <Select
          mode="multiple"
          allowClear
          size="small"
          placeholder="Sélectionner une catégorie"
          style={{ width: '100%' }}
          loading={isLoadingMpCategories}
          showSearch={true}
          filterOption={false}
          onChange={handleMpisNotCategoryChange}
          searchValue={searchedMpCategoryInput}
          onSearch={setSearchedMpCategoryInput}
          options={mpCategories?.map((category) => ({
            label: category.name,
            value: category.id,
          }))}
        />
      </Form.Item>
    </Form>
  );
};

export default ProductFilters;
